import {createContext, useState} from "react";
import {parseIfString} from "../../utils/Utils";

export const VariablesContext = createContext({})

const VariablesProvider = ({children}) => {
    const [variables, setVariables] = useState(null);
    const [checkpointVariables, setCheckpointVariables] = useState(null);
    const [diffVariables, setDiffVariables] = useState(null);

    const createSetter = (setter) => (value) => setter(parseIfString(value))

    const value = {
        variables,
        setVariables: createSetter(setVariables),
        checkpointVariables,
        setCheckpointVariables: createSetter(setCheckpointVariables),
        diffVariables,
        setDiffVariables: createSetter(setDiffVariables)
    };

    return (
        <VariablesContext.Provider value={value}>
            {children}
        </VariablesContext.Provider>
    );
}

export default VariablesProvider